export const styleConstants = {  MAIN_COLOR: '#505050',  LINK_COLOR: '#a12420',  ICON_COLOR: '#a12420',};